import { render, staticRenderFns } from "./consultNew.vue?vue&type=template&id=15c4a295&scoped=true&"
import script from "./consultNew.vue?vue&type=script&lang=js&"
export * from "./consultNew.vue?vue&type=script&lang=js&"
import style0 from "./consultNew.vue?vue&type=style&index=0&id=15c4a295&lang=scss&scoped=true&"
import style1 from "./consultNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4a295",
  null
  
)

export default component.exports